<div class="mb-dialog mb-dialog-custom">
  <mb-dialog-header>
    <h3
      class="mb-dialog-custom__header text"
      i18n="@@modals_hotelintro_ubicacion_del_alojamiento"
    >
      Ubicación del alojamiento
    </h3>
  </mb-dialog-header>
  <mb-dialog-body *ngIf="showMap">
    <div class="mb-dialog-custom__body">
      <ng-template #mapTemplate>
        <div #hotelsMap [style.height]="'100%'"></div>
      </ng-template>
      <ng-container *ngIf="showAvuxi; else mapTemplate">
        <avuxi
          type="map"
          [position]="hotelPosition"
          [brand]="brand"
          action="click"
        ></avuxi>
      </ng-container>
    </div>
  </mb-dialog-body>
</div>